import i18n from 'i18n';
import { toast } from 'helpers/toast';
import {
	CustomGroupListState,
	CustomGroupPaginatedResponse,
} from 'reducers/lms/customGroupManagement/customGroupList/type';
import * as actions from 'reducers/lms/customGroupManagement/customGroupList/customGroupList.action';
import * as types from 'reducers/lms/customGroupManagement/customGroupList/customGroupList.actionTypes';
import { takeLatest } from 'redux-saga/effects';
import { call, put, select } from 'typed-redux-saga';
import { RootState } from 'store/rootReducers';
import queryString from 'query-string';
import { fetchCustomGroups } from 'services/lms/lmsCustomGroupManagement.service';

function* getCustomGroupList(action: ReturnType<typeof actions.getCustomGroupList.request>) {
	try {
		const { page, limit, sortBy, sortDirection, search }: CustomGroupListState = yield select(
			(state: RootState) => state.lmsCustomGroupList,
		);

		const query: Record<string, any> = {
			page,
			limit,
			search,
			sortFields: sortBy,
			sortDirections: sortDirection,
		};

		const queryStr = queryString.stringify(query, { skipNull: true, skipEmptyString: true });
		const response: CustomGroupPaginatedResponse = yield* call(fetchCustomGroups, queryStr);

		yield put(actions.getCustomGroupList.success(response));
	} catch (e) {
		toast.error(i18n.t('message.lms.customGroupManagement.fetch.failed'));
		yield put(actions.getCustomGroupList.failure({ error: 'Failed to Fetch Custom Group List' }));
	}
}

export default function* customGroupListSaga() {
	yield takeLatest(types.GET_CUSTOM_GROUP_LIST_REQUEST, getCustomGroupList);
	yield takeLatest(types.SET_CUSTOM_GROUP_LIST_PAGE_INDEX, getCustomGroupList);
	yield takeLatest(types.SET_CUSTOM_GROUP_LIST_SEARCH_QUERY, getCustomGroupList);
	yield takeLatest(types.SET_CUSTOM_GROUP_LIST_SORT, getCustomGroupList);
}
